export default __webpack_public_path__ + "static/media/ru.8e2dcc8d.svg";